module.exports = __webpack_public_path__ + "img/withdraw.1387ee04.png";